import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MonitorState {
  /** Servers currently down, surfaced as a badge on the sidebar nav item. */
  ongoingIncidents: number;
}

const initialState: MonitorState = {
  ongoingIncidents: 0,
};

const monitorSlice = createSlice({
  name: 'monitor',
  initialState,
  reducers: {
    setOngoingIncidents: (state, action: PayloadAction<number>) => {
      state.ongoingIncidents = action.payload;
    },
  },
});

export const { setOngoingIncidents } = monitorSlice.actions;
export default monitorSlice.reducer;
